import "@/polyfills/structuredClone";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import { ThemeProvider } from "next-themes";
import { ApolloProvider } from "@apollo/client";
import client from "./api/apollo";
import App from "./App";
import ContextProvider from "./context/ContextProvider";
import { system } from "./theme/theme";

import "./main.css";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/toaster";

let root = document.getElementById("root");
if (root) {
  root.innerHTML = `
    <div id="page-loader">
      <img src="/static/LogoVector.svg" alt="" class="pulse-logo">
    </div>
  `;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <BrowserRouter>
        <ContextProvider>
          <ChakraProvider value={system}>
            <ThemeProvider
              attribute="class"
              disableTransitionOnChange
              forcedTheme="light"
            >
              <ErrorBoundary>
                <App />
                <Toaster />
              </ErrorBoundary>
            </ThemeProvider>
          </ChakraProvider>
        </ContextProvider>
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>,
);
